import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export function ProtectedRoute({ children }) {
    const { isLoggedIn } = useAuth();
    if (!isLoggedIn) return <Navigate to="/login" replace />;
    return children;
}

// Requires login AND the ADMIN role.
// The role value ('ADMIN') must match what the backend JWT payload returns.
export function AdminRoute({ children }) {
    const { isLoggedIn, role } = useAuth();
    if (!isLoggedIn) return <Navigate to="/login" replace />;
    if (role !== 'ADMIN') return <Navigate to="/" replace />;
    return children;
}
